import {
  Component,
  Inject,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import {
  MatDialogModule,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';

export interface DialogData {
  title: string;
  widgetTypes: {
    key: string;
    name: string;
    description: string;
    icon: string;
  }[];
}

@Component({
  selector: 'app-add-dashboard-item-dialog',
  standalone: true,
  imports: [
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
  ],
  template: `
    <h2 mat-dialog-title>{{ data.title || 'Tilføj Widget' }}</h2>
    <div mat-dialog-content>
      @if (!data.widgetTypes || data.widgetTypes.length === 0) {
      <div class="no-widgets-message">
        <p>Ingen widgets tilgængelige. Kontroller miljøindstillingerne.</p>
      </div>
      } @if (data.widgetTypes && data.widgetTypes.length > 0) {
      <div class="widget-types-grid">
        @for (type of data.widgetTypes; track type) {
        <div class="widget-type-card" (click)="selectWidgetType(type.key)">
          <div class="widget-type-icon">
            <mat-icon>{{ type.icon || 'widgets' }}</mat-icon>
          </div>
          <h3 class="widget-type-title">{{ type.name || type.key }}</h3>
          <p class="widget-type-desc">
            {{ type.description || 'Widget til dashboardet' }}
          </p>
        </div>
        }
      </div>
      }
    </div>
    <div mat-dialog-actions align="end">
      <button mat-button [mat-dialog-close]="null">Annuller</button>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      :host {
        display: block;
      }

      .no-widgets-message {
        text-align: center;
        padding: 20px;
        background-color: #f8fafc;
        border-radius: 8px;
        margin: 20px 0;

        p {
          color: #64748b;
          margin: 0;
        }
      }

      .widget-types-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
        gap: 16px;
        margin-bottom: 16px;
      }

      .widget-type-card {
        background-color: #f8fafc;
        border: 1px solid #e2e8f0;
        border-radius: 8px;
        padding: 16px;
        text-align: center;
        cursor: pointer;
        transition: background-color 0.2s ease, transform 0.2s ease;

        &:hover {
          background-color: #f1f5f9;
          transform: translateY(-2px);
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
            0 2px 4px -1px rgba(0, 0, 0, 0.06);
        }

        .widget-type-icon {
          display: flex;
          justify-content: center;
          margin-bottom: 10px;

          mat-icon {
            font-size: 28px;
            color: #4f46e5;
            height: 28px;
            width: 28px;
          }
        }

        .widget-type-title {
          margin: 0 0 8px;
          font-size: 16px;
          font-weight: 500;
          color: #334155;
        }

        .widget-type-desc {
          margin: 0;
          font-size: 13px;
          color: #64748b;
          line-height: 1.4;
        }
      }
    `,
  ],
})
export class AddDashboardItemDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<AddDashboardItemDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
  }

  ngOnInit() {
    // Log available widget types
  }

  selectWidgetType(type: string) {
    this.dialogRef.close(type);
  }
}
